module.exports = __webpack_public_path__ + "static/media/bowling-ball.5d02e8d0.svg";